import { Component, HostListener, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './services/auth/auth.service';
import { CoreService } from './modules/core/core.service';
import { UserChangePasswordFormDialogComponent } from './modules/user/components/user-change-password-form-dialog/user-change-password-form-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  innerWidth = 0;
  hasExpiredDocuments!: boolean;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.core.setIsMobile(window.innerWidth < 768);
  }

  @ViewChild('pwdDialog', { static: false })
  private pwdDialog!: UserChangePasswordFormDialogComponent;

  title = 'ΕΚΑΠΥ - Σύστημα Διαλειτουργικότητας';
  token$ = this.authService.token$;
  isMobile$ = this.core.isMobile$; isStageEnvironment = false;
  isSidebarVisible = false;

  constructor(
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private authService: AuthService,
    private core: CoreService
  ) {
    this.primengConfig.ripple = true;
    this.authService.hydrate();
  }

  ngOnInit(): void {
    this.translateService.setDefaultLang('el');
    this.translateService.use('el');
    this.translateService
      .get('primeng')
      .subscribe((res: any) => this.primengConfig.setTranslation(res));

    this.token$.subscribe((t) => {
      this.isStageEnvironment =
        (window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
          window.location.href.indexOf('local') !== -1) &&
          t
          ? true
          : false;

      if (!t) return;
    });

    this.authService.showPwdModal$.subscribe((show) => {
      if (!show || this.pwdModalOpen) return;

      const force = this.daysLeft <= 0 || this.changeNext;
      const lastWarn = this.authService.getLastWarnDays();

      if (force || isNaN(lastWarn) || this.daysLeft < lastWarn) {
        this.openPasswordModal(force);
      }
    });

  }

  ngAfterViewInit() {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
  }

  private get daysLeft(): number {
    return this.authService.pwdDaysLeft$.getValue();
  }
  private get changeNext(): boolean {
    return this.authService.changePwdNext$.getValue();
  }

  private pwdModalOpen = false;

  private openPasswordModal(force: boolean): void {
    this.pwdModalOpen = true;
    const daysLeft = this.daysLeft;

    this.core.confirmDialog({
      header: 'Λήξη κωδικού',
      message: force
        ? 'Ο κωδικός σας έχει λήξει. Πρέπει να τον αλλάξετε για να συνεχίσετε.'
        : `Ο κωδικός σας θα λήξει σε <b>${daysLeft}</b> ημέρες. ` +
        'Μπορείτε να συνεχίσετε ή να τον αλλάξετε τώρα.',
      acceptLabel: force ? 'Έξοδος' : 'Κλείσιμο',
      rejectLabel: 'Αλλαγή κωδικού',

      accept: () => {
        this.pwdModalOpen = false;

        if (force) {
          this.authService.clearLastWarnDays();
          this.authService.logout();
        } else {
          this.authService.setLastWarnDays(daysLeft);
        }
      },

      reject: () => {
        this.pwdModalOpen = false;

        if (this.pwdDialog) {
          this.pwdDialog.forceChange = force;
          this.pwdDialog.show();
        }

        if (!force) this.authService.setLastWarnDays(daysLeft);
      },
    });
  }
}
